export default {
  listTaStrategy: {
    accummulation: 'TÍCH LŨY',
    breakOut: 'VƯỢT ĐỈNH/THỦNG ĐÁY',
    breakOutMa: 'VƯỢT MA',
    bestInDowntrend: 'CP TỐT TRONG ĐÀ GIẢM',
    marketAnomaly: 'BIẾN ĐỘNG THỊ TRƯỜNG',
  },

  //filter tap 1
  filterAccumulationPeriod: {
    fiveDay: '>5D',
    tenDay: '>10D',
    twentyDay: '>20D',
    fourtyDay: '>40D',
  },

  filterVolumnRateOfChangeTabOne: {
    two: '>2',
    three: '>3',
    four: '>4',
    five: '>5',
  },

  filterIncreaseInPriceTabOne: {
    onePercen: '>1%',
    threePercen: '>3%',
    fivePercen: '>5%',
    sevenPercen: '>7%',
  },
  //

  //condition wrap
  filterAccumulationPeriodCondition: {
    1: '>5 ngày',
    2: '>10 ngày',
    3: '>20 ngày',
    4: '>40 ngày',
  },

  filterVolumnRateOfChangeTabOneCondition: {
    1: 'tỷ lệ khối lượng thay đổi >2',
    2: 'tỷ lệ khối lượng thay đổi >3',
    3: 'tỷ lệ khối lượng thay đổi >4',
    4: 'tỷ lệ khối lượng thay đổi >5',
  },

  filterIncreaseInPriceTabOneCondition: {
    1: 'giá tăng >1%',
    2: 'giá tăng >3%',
    3: 'giá tăng >5%',
    4: 'giá tăng >7%',
  },

  //filter tap 2
  filterBreakoutTopWithin: {
    threeMonth: '3M',
    sixMonth: '6M',
    nineMonth: '9M',
    oneYear: '1Y',
  },

  filterVolumnRateOfChangeTabTwo: {
    one: '>1',
    two: '>2',
    four: '>4',
    six: '>6',
  },

  filterStockGroupTabTwo: {
    all: 'TẤT CẢ',
    vn30: 'VN30',
    vnMid: 'VNMid',
    vnSmall: 'VNSmall',
  },

  //condition tab 2
  filterBreakoutTopWithinCondition: {
    1: 'vượt đỉnh > 3 month',
    2: 'vượt đỉnh > 6 month',
    3: 'vượt đỉnh > 9 month',
    4: 'vượt đỉnh > 1 year',
  },

  filterBreakoutTopWithinConditionBottom: {
    1: 'chạm đáy > 3 month',
    2: 'chạm đáy > 6 month',
    3: 'chạm đáy > 9 month',
    4: 'chạm đáy > 1 month',
  },

  filterVolumnRateOfChangeTabTwoCondition: {
    1: 'tỷ lệ khối lượng thay đổi >1',
    2: 'tỷ lệ khối lượng thay đổi >2',
    3: 'tỷ lệ khối lượng thay đổi >4',
    4: 'tỷ lệ khối lượng thay đổi >6',
  },

  filterStockGroupTabTwoCondition: {
    1: 'Tất cả',
    2: 'VN30',
    3: 'VNMid',
    4: 'VNSmall',
  },
  //

  //filter tap 3
  filterBreakoutMaBottom: {
    ma20: 'MA20',
    ma50: 'MA50',
    ma100: 'MA100',
    ma200: 'MA200',
  },

  filterVolumnRateOfChangeTabThree: {
    one: '>1',
    two: '>2',
    four: '>4',
    six: '>6',
  },

  filterIncreaseInPriceTabThree: {
    onePercen: '>1%',
    threePercen: '>3%',
    fivePercen: '>5%',
    sevenPercen: '>7%',
  },

  filterIncreaseInPriceTabThreeDown: {
    onePercen: '<-1%',
    threePercen: '<-3%',
    fivePercen: '<-5%',
    sevenPercen: '<-7%',
  },

  //condition tab 3
  filterBreakoutMaBottomCondition: {
    1: 'cắt lên MA20',
    2: 'cắt lên MA50',
    3: 'cắt lên MA100',
    4: 'cắt lên MA200',
  },

  filterBreakoutMaBottomConditionDown: {
    1: 'cắt xuống MA20',
    2: 'cắt xuống MA50',
    3: 'cắt xuống MA100',
    4: 'cắt xuống MA200',
  },

  filterVolumnRateOfChangeTabThreeCondition: {
    1: 'tỷ lệ khối lượng thay đổi >1',
    2: 'tỷ lệ khối lượng thay đổi >2',
    3: 'tỷ lệ khối lượng thay đổi >4',
    4: 'tỷ lệ khối lượng thay đổi >6',
  },

  filterIncreaseInPriceTabThreeCondition: {
    1: 'giá tăng >1%',
    2: 'giá tăng >3%',
    3: 'giá tăng >5%',
    4: 'giá tăng >7%',
  },

  filterIncreaseInPriceTabThreeConditionDown: {
    1: 'giá thay đổi < - 1%',
    2: 'giá thay đổi < - 3%',
    3: 'giá thay đổi < - 5%',
    4: 'giá thay đổi < - 7%',
  },
  //

  //filter tap 4
  filterVNIndexDowntrend: {
    recentSixMonth: '6T Gần Nhất',
    recentOneYear: '1N Gần Nhất',
    recentTwoYear: '2N Gần Nhất',
    recentThreeYear: '3N Gần Nhất',
  },

  filterAverageVol1mTabFour: {
    fivety: '>50,000',
    hundred: '>100,000',
    threeHundred: '>300,000',
    fiveHundred: '>500,000',
  },

  filterStockGroupTabFour: {
    all: 'Tất cả',
    vn30: 'VN30',
    vnMid: 'VNMid',
    vnSmall: 'VNSmall',
  },

  //condition tab 4
  filterVNIndexDowntrendCondition: {
    1: '6 tháng gần nhất',
    2: '1 năm gần nhất',
    3: '2 năm gần nhất',
    4: '3 năm gần nhất',
  },

  filterAverageVol1mTabFourCondition: {
    1: 'khối lượng hiện tại > 50,000',
    2: 'khối lượng hiện tại > 100,000',
    3: 'khối lượng hiện tại> 300,000',
    4: 'khối lượng hiện tại > 500,000',
  },

  filterStockGroupTabFourCondition: {
    1: 'Tất cả',
    2: 'VN30',
    3: 'VNMid',
    4: 'VNSmall',
  },

  theHighestEps: 'EPS lớn nhất',
  //

  //filter tap 5
  filterHighestReturnDaily: {
    monDay: 'Thứ 2',
    tuesDay: 'Thứ 3',
    wednesDay: 'Thứ 4',
    thursDay: 'Thứ 5',
    friDay: 'Thứ 6',
  },

  filterHighestReturnMonthly: {
    jan: 'T1',
    feb: 'T2',
    mar: 'T3',
    apr: 'T4',
    may: 'T5',
    jun: 'T6',
    jul: 'T7',
    aug: 'T8',
    sep: 'T9',
    oct: 'T10',
    nov: 'T11',
    dec: 'T12',
  },

  filterHighestReturnQuarterly: {
    Q1: 'Q1',
    Q2: 'Q2',
    Q3: 'Q3',
    Q4: 'Q4',
  },

  filterCaculationPeriod: {
    lastThreeYear: 'Trong 3 Năm',
    lastFiveYear: 'Trong 5 Năm',
    lastThenYear: 'Trong 10 Năm',
    allTime: 'Tất cả',
  },

  filterAverageVol1mTabFive: {
    fivety: '>50,000',
    hundred: '>100,000',
    threeHundred: '>300,000',
    fiveHundred: '>500,000',
  },

  filterStockGroupTabFive: {
    all: 'Tất cả',
    vn30: 'VN30',
    vnMid: 'VNMid',
    vnSmall: 'VNSmall',
  },

  //condition tab 5
  filterHighestReturnCondition: {
    1: 'Lợi suất cao nhất vào thứ 2',
    2: 'Lợi suất cao nhất vào thứ 3',
    3: 'Lợi suất cao nhất vào thứ 4',
    4: 'Lợi suất cao nhất vào thứ 5',
    5: 'Lợi suất cao nhất vào thứ 6',
  },
  filterHighestReturnConditionMonthly: {
    1: 'Lợi suất cao nhất vào tháng 1',
    2: 'Lợi suất cao nhất vào tháng 2',
    3: 'Lợi suất cao nhất vào tháng 3',
    4: 'Lợi suất cao nhất vào tháng 4',
    5: 'Lợi suất cao nhất vào tháng 5',
    6: 'Lợi suất cao nhất vào tháng 6',
    7: 'Lợi suất cao nhất vào tháng 7',
    8: 'Lợi suất cao nhất vào tháng 8',
    9: 'Lợi suất cao nhất vào tháng 9',
    10: 'Lợi suất cao nhất vào tháng 10',
    11: 'Lợi suất cao nhất vào tháng 11',
    12: 'Lợi suất cao nhất vào tháng 12',
  },

  filterHighestReturnConditionQuaterly: {
    1: 'Lợi suất cao nhất vào quý 1',
    2: 'Lợi suất cao nhất vào quý 2',
    3: 'Lợi suất cao nhất vào quý 3',
    4: 'Lợi suất cao nhất vào quý 4',
  },

  filterCaculationPeriodCondition: {
    1: '3 năm',
    2: '5 năm',
    3: '10 năm',
    4: 'Tất cả',
  },

  filterAverageVol1mTabFiveCondition: {
    1: 'K.L T.bình 1 Tháng > 50,000',
    2: 'K.L T.bình 1 Tháng > 100,000',
    3: 'K.L T.bình 1 Tháng > 300,000',
    4: 'K.L T.bình 1 Tháng > 500,000',
  },

  filterStockGroupTabFiveCondition: {
    1: 'Tất cả',
    2: 'VN30',
    3: 'VNMid',
    4: 'VNSmall',
  },

  // close filter

  tableAccumulation: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOL: 'K.L',
    RSI14: 'RSI14',
    MA20: 'MA20',
    PRICE_PREV: 'GIÁ <br><small>(TRƯỚC)</small></br>',
    VOL_PREVIOUS: 'K.L <br><small>(TRƯỚC)</small></br>',
    PRICE_AVG: 'GIÁ <br><small>(T.bình 10D)</small></br>',
    VOL_AVG: 'K.L <br><small>(T.bình 10D)</small></br>',
    RANKING: 'XẾP HẠNG',
  },

  tableBreakOut: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOL: 'K.L',
    AVG_VOL_1M: 'K.L T.bình 1M',
    RSI14: 'RSI14',
    MA20: 'MA20',
    TOP_PREVIOUS: 'GIÁ ĐỈNH <br><small>(Trước)</small></br>',
    PE: 'P/E',
    PB: 'P/B',
    RANKING: 'XẾP HẠNG',
  },

  tableBreakOutBottom: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOL: 'K.L',
    AVG_VOL_1M: 'K.L T.bình 1M',
    RSI14: 'RSI14',
    MA20: 'MA20',
    BOTTOM_PREVIOUS: 'GIÁ ĐÁY <br><small>(Trước)</small></br>',
    PE: 'P/E',
    PB: 'P/B',
    RANKING: 'XẾP HẠNG',
  },

  tableBreakOutMa: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    MA5: 'MA5',
    MA20: 'MA20',
    MA50: 'MA50',
    MA100: 'MA100',
    MA200: 'MA200',
    VOL: 'K.L',
    RSI14: 'RSI14',
    RANKING: 'XẾP HẠNG',
  },

  tableBestInDowntrend: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOL: 'K.L',
    AVG_VOL_1M: 'K.L T.bình 1M',
    RETURN_DOWNTREND: 'LỢI SUẤT <br><small>(XU HƯỚNG GIẢM)</small></br>',
    RETURN_RECOVERY: 'LỢI SUẤT <br><small>(PHỤC HỒI)</small></br>',
    PE: 'P/E',
    PB: 'P/B',
    MA20: 'MA20',
    RANKING: 'XẾP HẠNG',
  },

  tableMarketAnomaly: {
    TICKER: 'MÃ',
    PRICE: 'GIÁ',
    VOL: 'K.L',
    AVG_RETURN: 'LỢI SUẤT T.BÌNH',
    MEDIUM_RETURN: 'MEDIUM RETURN',
    RSI14: 'RSI14',
    MA20: 'MA20',
    PE: 'P/E',
    PB: 'P/B',
    RANKING: 'XẾP HẠNG',
  },

  titleFilterAccumulation: {
    titleOne: 'Giai đoạn tích lũy',
    titleTwo: 'Tỷ lệ khối lượng thay đổi',
    titleThree: 'Giá Tăng',
  },

  titleFilterBreakout: {
    titleOne: 'Vượt đỉnh trong',
    titleTwo: 'Tỷ lệ khối lượng thay đổi ',
    titleThree: 'Nhóm Cổ phiếu',
  },

  titleFilterBreakoutBottom: {
    titleOne: 'Xuống đáy trong',
    titleTwo: 'Tỷ lệ khối lượng thay đổi',
    titleThree: 'Nhóm Cổ phiếu',
  },

  titleFilterBreakoutMa: {
    titleOne: 'Vượt MA',
    titleTwo: 'Tỷ lệ khối lượng thay đổi',
    titleThree: 'Giá thay đổi',
  },

  titleFilterBestInDowntrend: {
    titleOne: 'Xu Hướng Giảm VN-Index',
    titleTwo: 'K.L T.bình 1M',
    titleThree: 'Nhóm cổ phiếu',
  },

  titleFilterMarketAnomaly: {
    titleOne: 'Lợi suất cao nhất',
    titleTwo: 'Giai đoạn tính toán',
    titleThree: 'K.L T.bình 1M',
    titleFour: 'Nhóm cổ phiếu',
  },

  overviewAccummulation: {
    leftTick: 'ANB',
    rightName: 'Tích lũy và Vượt',
    rightCharacteristics: 'K.L TĂNG ĐÁNG KỂ TRONG 1 GIAI ĐOẠN',
  },

  overviewBreakOut: {
    leftTick: 'BTB',
    rightName: 'Vượt đỉnh hoặc Thủng đáy',
    rightCharacteristics: 'CỔ PHIẾU VƯỢT ĐỈNH HOẶC THỦNG ĐÁY',
  },

  overviewBreakOutMa: {
    leftTick: 'BMA',
    rightName: 'VƯỢT MA',
    rightCharacteristics: 'CỔ PHIẾU VƯỢT MA20 / MA50 / MA100 / MA200',
  },

  overviewBestInDowntrend: {
    leftTick: 'BID',
    rightName: 'Cổ phiếu tốt trong xu hướng giảm',
    rightCharacteristics: 'CỔ PHIẾU VỚI LỢI NHUẬN CAO NHẤT TRONG ĐÀ GIẢM',
  },

  overviewMarketAnomaly: {
    leftTick: 'ANO',
    rightName: 'Biến động thị trường',
    rightCharacteristics: 'BIẾN ĐỘNG GIÁ VÀ LỢI TỨC CÓ SỰ BẤT THƯỜNG',
  },

  defaultAccummulationfilter: {
    stockAccumulate: 'Cổ phiếu tích lũy ',
    with: 'với ',
    and: 'và ',
  },

  defaultBreakOutfilter: {
    stockIn: 'Cổ phiếu trong ',
    that: 'đó ',
    with: 'với ',
  },

  defaultBreakOutMafilter: {
    stockThat: 'Cổ phiếu đó ',
    with: 'với ',
    and: 'và ',
  },

  defaultBestInDowntrendfilter: {
    stockIn: 'Cổ phiếu trong ',
    with: 'với ',
    and: 'và ',
    within: 'trong ',
  },

  defaultMarketAnomalyfilter: {
    stockIn: 'Cổ phiếu trong ',
    with: 'với ',
    and: 'và ',
    over: 'tất cả trong ',
  },

  condition: 'Điều kiện : ',

  groupRadioButtonBreakOut: {
    top: 'Đỉnh',
    bottom: 'Đáy',
  },

  groupRadioButtonBreakOutMa: {
    crossUp: 'Vượt lên',
    crossDown: 'Cắt xuống',
  },

  groupRadioButtonMarketAnomaly: {
    daily: 'Ngày',
    monthly: 'Tháng',
    quarterly: 'Qúy',
  },
};
